import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69cee97fc3f8480013a5a84c/stylesyndicate/src/app/sign-up-login-screen/components/AuthForm.tsx");
